import AddDocFirmatoController from "./add_doc_firmato/AddDocFirmatoController";
import React, {useContext, useEffect, useState} from "react";
import DocFirmatoController from "./show_doc_firmato/DocFirmatoController";
import {LoaderContext} from "../../../../context/LoaderContext";
import {getDocumentoFirmatoApi} from "../../../../services/CertificatiServices";

export default function DocFirmatoContainerController({
                                                          idCertificato
                                                      }) {

    const [documento, setDocumento] = useState();

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    async function getDocumentoFirmato() {
        startChiamata();

        const response = await getDocumentoFirmatoApi(idCertificato);
        setDocumento(response.data.data);
        endChiamata();
    }

    useEffect(() => {
        getDocumentoFirmato();
    }, [idCertificato]);

    return (
        documento ?
            <DocFirmatoController
                documento={documento}
                onUpdate={getDocumentoFirmato}
            />
            :
            <AddDocFirmatoController
                idCertificato={idCertificato}
                submitOk={getDocumentoFirmato}
            />
    );

}